// Import Components from react library
import React from 'react';
import { useEffect, useState } from "react";

// CSS file for this page;
import '../styles/Slider.css';


function Slider({id, min, max, selectYear}) {

    // State variables using useState hook
    // To store the selected year locally
    const [inputYear, setInputYear] = useState(min);


    // Set the inputYear from the slider On Change
    const handleInputYear = (e) => {

        // To store the selected year locally
        setInputYear(e.target.value);

        // Store the selected year for the parent component
        selectYear(e.target.value);
    };

    return (
        <>
            <div className="year-slider">

                {/* Label to show the selected year */}
                <label className='slider-label' htmlFor={id}>
                    Year
                    <div id="input-year-value">
                        {inputYear}
                    </div>
                </label>

                {/* The Slider itself */}
                <input
                    id={id}
                    type="range"
                    min={min}
                    max={max}
                    step="1"
                    value={inputYear}
                    onChange={handleInputYear}
                />

            </div>
        </>
    );
}

export default Slider;
